import classNames from 'classnames';
import * as React from 'react';
import style from './icon.module.css';

interface Icons {
	[key: string]: any;
}

interface Sizes {
	[name: string]: number | string;
}

type Props = {
	/**
	 * Icon name.
	 */
	name?: string;
	/**
	 * Icon size
	 */
	size?: 'responsive' | 'xsmall' | 'small' | 'medium' | 'large';
	color?: ColorType;
};

const SIZE_RESPONSIVE = 'responsive';
const SIZE_EXTRA_SMALL = 'xsmall';
const SIZE_SMALL = 'small';
const SIZE_MEDIUM = 'medium';
const SIZE_LARGE = 'large';

/* Sizes values */
const SIZES: Sizes = {
	[SIZE_EXTRA_SMALL]: 13,
	[SIZE_SMALL]: 17,
	[SIZE_MEDIUM]: 22,
	[SIZE_LARGE]: 34,
	[SIZE_RESPONSIVE]: '100%',
};

/**
 * Icon component
 */
export const Icon: React.FC<Props> = ({
	name = '',
	size = SIZE_RESPONSIVE,
	color = '',
}) => {
	const sizeValue = SIZES[size] || size;

	return (
		<svg
			width={sizeValue}
			height={sizeValue}
			className={classNames(style.container, color, {
				[style.closeIcon]: name === 'close',
			})}
		>
			<use xlinkHref={`#${name}`} href={`#${name}`} />
		</svg>
	);
};
